import { RolesTab } from './RolesTab';
import { ROUTE_QUERY_PARAM } from '../../app/Routes/const';
import { Tabs, Tab } from '../../components';
import { PermissionsTab } from './PermissionsTab';
import { useTabPersistence } from '../../shared';

type TabsEnum = 'roles' | 'permissions';
const ROLES_AND_PERMISSIONS_TABS: TabsEnum[] = ['roles', 'permissions'];

const RolesAndPermissionsPage = () => {
  const { selectedTab, setSelectedTab } = useTabPersistence(
    {
      paramName: ROUTE_QUERY_PARAM.TAB,
      defaultTab: ROLES_AND_PERMISSIONS_TABS[0],
      updateHistory: true,
    },
    ROLES_AND_PERMISSIONS_TABS
  );

  return (
    <>
      <Tabs<TabsEnum>
        tabs={[
          { name: 'roles', label: 'Roles' },
          { name: 'permissions', label: 'Permissions' },
        ]}
        activeTab={selectedTab}
        onChange={setSelectedTab}
        contentClassName="mt-md"
      >
        <Tab name="roles">
          <RolesTab />
        </Tab>
        <Tab name="permissions">
          <PermissionsTab />
        </Tab>
      </Tabs>
    </>
  );
};

export default RolesAndPermissionsPage;
